import { withAuthenticationRequired } from "@auth0/auth0-react";
import { ComponentType } from "react";

interface AuthenticationGuardProps {
  component: ComponentType;
}

export default function AuthenticationGuard({ component }: AuthenticationGuardProps) {
  const Component = withAuthenticationRequired(component, {
    // onRedirecting: () => <div className="page-layout">{<PageLoader />}</div>,
  });

  return <Component />;
}
